export const transformResource = (resource: any) => {
  return {
    key: resource.id,
    title: resource.title,
    category: resource.category,
    author: resource.author,
    numberOfHits: resource.numberOfHits,
  };
};
